import type { IContextMutationResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import { useToastStore } from '@modules/toast/store';

import {
  AFFILIATE_DELETE_TRACKER_GROUPS_API_URL,
  AFFILIATE_DELETE_TRACKER_GROUPS_MUTATION,
  AFFILIATE_SHOW_TRACKER_GROUP_ITEM_QUERY,
  AFFILIATES_TRACKER_GROUPS_PERMISSIONS,
} from '../constants';

export default function useDeleteHistoryOfTrackerGroupsMutation(): IContextMutationResult<
  void,
  Error,
  number
> {
  const { fetchDelete } = useRestClient();
  const { displayPresetToast } = useToastStore();

  return useContextMutation<void, Error, number>({
    mutationKey: [AFFILIATE_DELETE_TRACKER_GROUPS_MUTATION],
    mutationFn: (id) => fetchDelete<void>(
      AFFILIATE_DELETE_TRACKER_GROUPS_API_URL,
      {
        permission: AFFILIATES_TRACKER_GROUPS_PERMISSIONS.DELETE,
        urlParams: {
          id,
        },
      },
    ),
    async onSuccess({ queryClient }) {
      await queryClient.invalidateQueries({ queryKey: [AFFILIATE_SHOW_TRACKER_GROUP_ITEM_QUERY] });
      displayPresetToast('removed');
    },
  });
}
